module.exports = __webpack_public_path__ + "img/ico_setting.5600e17e.svg";